import { render, staticRenderFns } from "./TaxLayout.vue?vue&type=template&id=6dc1f678"
import script from "./TaxLayout.vue?vue&type=script&lang=js"
export * from "./TaxLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports